import { get, sortBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getOutreachAggregateOptions = get(
  'report.outreachAggregateOptions'
);

export const getOutreachAggregateLocationOptions = createSelector(
  getOutreachAggregateOptions,
  get('locations')
);

export const getOutreachAggregateTrackingMethodOptions = createSelector(
  getOutreachAggregateOptions,
  get('trackingMethods')
);

export const getSortedOutreachAggregateTrackingMethodOptions = createSelector(
  getOutreachAggregateTrackingMethodOptions,
  sortBy('label')
);

export const getIsFetchingOutreachAggregateOptions = createSelector(
  getOutreachAggregateOptions,
  get('fetching')
);

export const getIsFetchedOutreachAggregateOptions = createSelector(
  getOutreachAggregateOptions,
  get('fetched')
);

export const getFetchingOutreachAggregateOptionsError = createSelector(
  getOutreachAggregateOptions,
  get('fetchingError')
);
